type Props = {
  svgProps?: React.SVGProps<SVGSVGElement>
  iconColor?: string
}

export const ExternalLinkIcon = ({ iconColor, svgProps }: Props) => {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      {...svgProps}
    >
      <path
        d="M10.5 1.5L5.5 6.5M10.5 1.5H7.5M10.5 1.5V4.5M4.5 1.5H2.5C1.94772 1.5 1.5 1.94772 1.5 2.5V9.5C1.5 10.0523 1.94772 10.5 2.5 10.5H9.5C10.0523 10.5 10.5 10.0523 10.5 9.5V7.5"
        stroke={iconColor || 'currentColor'}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
